import React, { useCallback, useEffect, useMemo, useState } from 'react';

import FlatTreeMavenir from '@components/routes/CmModule/ConfigurationComparison/MOTreeMavenir/FlatTreeMavenir';

import { useMutateSelectedPaths } from '@hooks/cmModule/useMutateSelectedPaths';

import { convertToMavenirFlatTreeData } from '@utils/treeFormatter/treeFormatter';

import { ICategoryPath, IFlatMoTreeNode, IMoTreeInitial } from '@interfaces/components/tree';

import { preparePaths } from './utils';

import styles from './MoTreeMavenir.module.scss';

interface IMoTreeMavenirProps {
	moTree?: IMoTreeInitial;
	handleSubmit: (value: Array<ICategoryPath>) => void;
	treeId?: string;
	isDisabledSubmit?: boolean;
}

const MoTreeMavenir = ({ moTree, handleSubmit, treeId, isDisabledSubmit }: IMoTreeMavenirProps) => {
	const [data, setData] = useState<IFlatMoTreeNode[]>([]);

	const preparedTree = useCallback(() => {
		if (!moTree) return [];

		const array = convertToMavenirFlatTreeData({
			data: moTree ? [moTree] : [],
			collapseDepth: 1,
		});

		return array;
	}, [moTree]);

	const treeData = useMemo(() => preparedTree(), [preparedTree]);

	useEffect(() => {
		setData(treeData);
	}, [treeData]);

	const { getNodePaths, isLoadingGetNodePaths } = useMutateSelectedPaths();

	const submitHandler = useCallback((data: IFlatMoTreeNode[]) => {
		handleSubmit(preparePaths(data));
	}, [handleSubmit]);

	return (
		<div className={styles.MoTreeMavenirContainer}>
			<FlatTreeMavenir
				data={data}
				isDisabledSubmit={isDisabledSubmit}
				isLoading={isLoadingGetNodePaths}
				setData={setData}
				submitHandler={submitHandler}
				treeId={treeId}
				updateConfig={getNodePaths}
			/>
		</div>
	);
};

export default MoTreeMavenir;
